import { useState } from "react";
import { InputRow } from "../../utils/inputRow";
import PassageTableRow from "./PassageTableRow";
import ClearButton from "./ClearButton";

let rowKey = 0;

interface Props {
  onUpdate: (e: InputRow[]) => void;
}

const PassageTable = (props: Props) => {
  const [rowInputs, setRowInputs] = useState<InputRow[]>(JSON.parse(localStorage.getItem("rowInputs") || "[]"));

  const updateRows = (rows: InputRow[]) => {
    const reindexed = rows.map((r, i) => ({ ...r, id: i }));
    setRowInputs(reindexed);
    props.onUpdate(reindexed);
  };

  const storeRowInput = (e: InputRow) => {
    const idx = rowInputs.findIndex((p) => p.id === e.id);
    if (idx === -1) {
      updateRows([...rowInputs, e]);
    } else {
      const updated = [...rowInputs];
      updated[idx] = e;
      updateRows(updated);
    }
  };

  const rowUp = (id: number) => {
    if (id < 1) return;
    const updated = [...rowInputs];
    const tmp = updated[id];
    updated[id] = updated[id - 1];
    updated[id - 1] = tmp;
    updateRows(updated);
  };

  const rowDown = (id: number) => {
    if (id > rowInputs.length - 2) return;
    const updated = [...rowInputs];
    const tmp = updated[id];
    updated[id] = updated[id + 1];
    updated[id + 1] = tmp;
    updateRows(updated);
  };

  const deleteRow = (id: number) => {
    const filtered = rowInputs.filter((_, i) => i !== id);
    updateRows(filtered);
  };

  const rows = rowInputs.map((e, i) => (
    <PassageTableRow
      key={e.id + "-" + rowKey++}
      first={i === 0}
      last={i === rowInputs.length - 1}
      rowInput={e}
      fixed={true}
      onComplete={storeRowInput}
      onUp={rowUp}
      onDown={rowDown}
      onDelete={deleteRow}
    />
  ));
  rows.push(
    <PassageTableRow
      key={"new-" + rowKey++}
      fixed={false}
      onComplete={storeRowInput}
      onUp={rowUp}
      onDown={rowDown}
      onDelete={deleteRow}
    />
  );

  return (
    <div className="m-5 p-5 border rounded">
      <div className="flex mb-3">
        <div className="flex-grow"></div>
        <ClearButton
          onClick={() => {
            setRowInputs([]);
            props.onUpdate([]);
          }}
        />
      </div>
      <div
        className="
          hidden
          md:grid
          md:grid-cols-[minmax(40px,1fr)_minmax(160px,2fr)_minmax(70px,1fr)_minmax(70px,1fr)_minmax(190px,3fr)_minmax(70px,1fr)]
          md:gap-x-3
          lg:grid-cols-[minmax(40px,1fr)_minmax(160px,2fr)_minmax(70px,1fr)_minmax(70px,1fr)_minmax(320px,3fr)_minmax(70px,1fr)]
          lg:gap-x-6
          font-bold
          text-slate-700
          pb-1
        "
      >
        <div className="pl-[2px]">Type</div>
        <div>Book</div>
        <div>Chapter</div>
        <div>Verses</div>
        <div>Translation</div>
        <div className="flex justify-center">Options</div>
      </div>
      {rows}
    </div>
  );
};

export default PassageTable;
